module.exports = __webpack_public_path__ + "img/logo-cirle-white.ebb134fd.png";